/**
 * Получение параметров сессии.
 * Мокирование сессии для нужд разработки
 *
 *
 * @type {SessionHelper|*|{}}
 */

/*global SessionHelper: true */
var SessionHelper = SessionHelper || {};

(function(ext) {

  'use strict';

  var mockParameters = '';
  var apiServer = '';
  var appParams = {};

    /**
     * Задать mock параметры сессии (режим разработки)
     * @param mock
     */
  ext.setMockParameters = function(mock) {
    mockParameters = mock;

    appParams = FAPI.Util.getRequestParameters();
    if (!appParams.session_key) {
      appParams = createParametersFromMock();
      if (apiServer) {
        appParams.api_server = apiServer;
      }
      console.log('INFO: Using mock parameters: ' + appParams);

      FAPI.Util.getRequestParameters = function() {
        return appParams;
      };
    }
  };

    /**
     * Задать сервер АПИ
     * @param url
     */
  ext.setApiServer = function(url) {
    apiServer = url;
  };

  function createParametersFromMock() {
    var res = {};

    try {
            // предполагаем сначала что строка имеет вид json-объекта
      res = JSON.parse(mockParameters);
    }
    catch(e) {
            // иначе пытаемся разобрать строку типа ключ=значение
      var ar = mockParameters.split('&amp;');
      if (ar.length <= 1) {
        ar = mockParameters.split('&');
      }
      ar.forEach(function(e) {
        res[e.split('=')[0]] = e.split('=')[1];
      });
    }

    return res;
  }

    /**
     * Получить параметры сессии
     * @returns {*}
     */
  ext.getAppParams = function() {
    return FAPI.Util.getRequestParameters();

  };

}(SessionHelper));